import type { SVGProps } from 'react';

const SvgCloseBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M19 5L5 19' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
    <path d='M19 19L5 5' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
  </svg>
);
export default SvgCloseBd;
